"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconHouseBlockOutline = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  viewBox: "0 0 18 18",
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "hboa",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1440 0v1892H0V0h1440Z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "hbob",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M15 0v18H0V0h15Zm-2 2H2v14h11V2ZM6.5 12v2h-2v-2h2Zm4 0v2h-2v-2h2Zm-4-4v2h-2V8h2Zm4 0v2h-2V8h2Zm-4-4v2h-2V4h2Zm4 0v2h-2V4h2Z"
      })
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    clipPath: "url(#hboa)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      clipPath: "url(#hbob)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0 0h15v18H0V0z"
      })
    })
  })]
});
var _default = exports.default = (0, _withIcon.default)('IconHouseBlockOutline')(IconHouseBlockOutline);